import React from 'react';

const Cover = ({ src, isLarge }) => {
  const className = isLarge ? 'cover--large' : 'cover';

  return <div className={className}>{src && <img src={src} className="cover__img" alt="" />}</div>;
};

export default Cover;
